import { ReviewsPage } from '../../../components/pages/products/reviews/ReviewsPage'
export default ReviewsPage
